import React, { useContext, useState } from "react";
import Sidebar from "../components/dashboardLayout/sidebar/SideBar";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Dashboard from "../layout/Dashboard";
import PoliciesPage from "../layout/PoliciesPage";
import PoliciesDetailsPage from "../layout/PoliciesDetailsPage";
import PoliciesEditPage from "../layout/PoliciesEditPage";
import ContactUsPage from "../layout/ContactUsPage";
// import Notification from "../layout/notification";
import Notification from "../layout/notification";
import Header from "../components/dashboardLayout/header";
import Footer from "../components/Footer";
import Breadcrumb from "../components/dashboardLayout/breadcrumb";
import Profile from "../layout/profile";
import EmailTemplates from "../layout/emailTemplates";
import AddTemplates from "../layout/addTemplate";
import ChangePassword from "./changePassword";
import EditProfile from "../layout/editProfile";
import UsersPage from "../layout/UsersPage";
import UserDetails from "../layout/UserDetails";
import Language from "../layout/language";
import AddStaff from "../layout/addStaff";
import EditTemplates from "../layout/editTemplates";
import AddFaq from "../layout/addFaq";
import PublicPhoto from "../layout/PublicPhoto";
import PrivatePhoto from "../layout/PrivatePhoto";
import PoliciesAddPage from "../layout/PoliciesAddPage";
import { GlobalContext } from "../context/Provider";
import { ROLES_DASHBOARD } from "../constants/actionTypes";
import StoriesPage from "../layout/StoriesPage";
import PostsPage from "../layout/PostsPage";
import ReelsPage from "../layout/ReelsPage";
import ReportedPosts from "../layout/ReportedPosts";
import ReportedStories from "../layout/ReportedStories";
import ReportedReels from "../layout/ReportedReels";
import UserMessages from "../layout/UserMessages";
import Suscribes from "../layout/suscriber";
import TermsofServicesPrivacyPolicy from "../layout/TermsofServicesPrivacyPolicy";
import Logout from "../layout/Logout";
import UserMessageDetails from "../layout/UserMessageDetails";
import Transaction from "../layout/transaction";
import MediaDetails from "../layout/mediaDetails";
import RaceListPage from "../layout/RacePage";
import AddRace from "../layout/addRace";
import EditRace from "../layout/editRace";
import RaceView from "../layout/ViewRace";
import ReportedChat from "../layout/ReportedChat";
import ReportedMessage from "../layout/ReportedMessage";

function DashboardLayout() {
  const { authState, loading } = useContext(GlobalContext);
  const roles = Array.isArray(authState.roles) ? authState.roles : [];

  let location = useLocation();

  const [isVisible, setIsVisible] = useState(false);
  const toggle = () => setIsVisible(!isVisible);

  return (
    <div id="wrapper">
      <Sidebar isVisible={isVisible} toggle={toggle} />
      <div id="page-wrapper" class="gray-bg">
        <Header toggle={toggle} />
        {location.pathname !== "/" ? (
          <Breadcrumb {...location} />
        ) : authState.super_admin ? (
          ""
        ) : (
          <Breadcrumb {...location} />
        )}
        <div className="wrapper wrapper-content">
          <Routes>
            {roles.includes(ROLES_DASHBOARD) || authState.super_admin ? (
              <Route path="/" element={<Dashboard />} />
            ) : (
              <Route path="/" element={<Profile />} />
            )}
            <Route path="/policies" element={<PoliciesPage />} />
            <Route path="/policies/add" element={<PoliciesAddPage />} />
            <Route path="/policies/:id/:type" element={<PoliciesDetailsPage />} />
            <Route path="/policies/:id/:type/edit" element={<PoliciesEditPage />} />
            <Route path="/contact-us/:page" element={<ContactUsPage />} />
            <Route path="/notification" element={<Notification />} />
            <Route path="/profile/edit" element={<EditProfile />} />
            <Route path="/profile" element={<Profile />} />
            {/* <Route path="/staffs/:page/:role" element={<StaffManagement />} />
            <Route path="/staff/:id" element={<StaffDetails />} />
            <Route path="/staff/edit/:id" element={<EditStaff />} />
            <Route path="/staff/add" element={<AddStaff />} /> */}
            <Route path="/race" element={<RaceListPage />} />
            <Route path="/reported-race" element={<RaceListPage />} />
            <Route path="race/add" element={<AddRace />} />
            <Route path="race/:id/edit" element={<EditRace />} />
            <Route path="/race/:id/view" element={<RaceView />} />
            <Route path="/email-template" element={<EmailTemplates />} />
            <Route path="/add-template" element={<AddTemplates />} />
            <Route path="/edit-template" element={<EditTemplates />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/reels/:page" element={<ReelsPage />} />
            <Route path="/reported-posts/:page" element={<ReportedPosts />} />
            <Route path="reported-chat/:id/view" element={<ReportedMessage />} />
            <Route path="/reported-chat/:page" element={<ReportedChat />} />
            <Route path="/reported-reels/:page" element={<ReportedReels />} />
            <Route path="/media/:id/:type" element={<MediaDetails />} />
            <Route
              path="/reported-stories/:page"
              element={<ReportedStories />}
            />

            <Route path="/user-Messages/:page" element={<UserMessages />} />
            <Route
              path="/user-Message-Details/:id"
              element={<UserMessageDetails />}
            />
            <Route
              path="/termServicesPrivacyPolicy/:page"
              element={<TermsofServicesPrivacyPolicy />}
            />
            <Route path="/logout/:page" element={<Logout />} />
            <Route path="/users/:page" element={<UsersPage />} />
            <Route path="/user/:id/:type/:page" element={<UserDetails />} />
            <Route path="/stories/:page" element={<StoriesPage />} />
            <Route path="/faq/add" element={<AddFaq />} />
            <Route path="/language" element={<Language />} />
            <Route path="/posts/:page" element={<PostsPage />} />
            <Route
              path="/posts/:id/photos/public/:page"
              element={<PublicPhoto />}
            />
             <Route path="/suscriber/:page" element={<Suscribes />} />
             <Route path="/transaction/:page" element={<Transaction />} />
            <Route
              path="/posts/:id/photos/private/:page"
              element={<PrivatePhoto />}
            />
          </Routes>
        </div>

        <Footer />
      </div>
    </div>
  );
}

export default DashboardLayout;
